import { Action, type ActionProps } from '@cvent/analytics/Action';
import { MapView } from '@/constants/mapConstants';

/**
 * Properties that will be tracked as part of this action.
 */
export interface SearchbarSearchProps extends ActionProps {
  /**
   * Fact type
   */
  type: 'csn_search_bar';
  /**
   * Map view
   */
  map_view: MapView;
  /**
   * Search location
   */
  search_term: string;
  /**
   * Page URL
   */
  page_url: string;
  /**
   * Start date
   */
  eventStartDate: string;
  /**
   * End date
   */
  eventEndDate: string;
  /**
   * Attendee count
   */
  attendeeCount: number | 'null';
  /**
   * Guest room count
   */
  guestRoomCount: number | 'null';
  /**
   * Current page number
   */
  current_page_number: number;
  /**
   * Page
   */
  page: string;
  /**
   * Check in date
   */
  checkInDate: string;
  /**
   * Check out date
   */
  checkOutDate: string;
}

/**
 * @description This action tracks unique searches on the CSN search page
 * @trigger This action is triggered when a user searches/ updates any filter on search bar
 */
export class SearchbarSearch extends Action<SearchbarSearchProps> {
  id = 'searchbar.search';
}

export default SearchbarSearch;
